module.exports = __webpack_public_path__ + "img/photos/offer-04a.jpg";